import React from "react";
import PropTypes from "prop-types";
import * as DomainConstants from "../../constants/DomainConstants";
import ValidationGroup from "../common/ValidationGroup";
import CheckBoxWithChild from "../common/CheckBoxWithChild";
import { orderByPropertyName } from "../../util/orderBy";
import { Popup } from 'semantic-ui-react';
import Tooltip from "../common/Tooltip";

const RenovatieInfrastructurenTable = props => {
	const {
		infrastructurenInDeBuurt,
		errors,
		validationMessageType,
		disabled
	} = props;

	const onEdit = (id) => {
		return function () {
			return props.onEdit(id);
		};
	};

	const onChange = (id) => {
		return function (event) {
			return props.onChange(event, id);
		};
	};

	function findById(id) {
		const type = props.soortenInfrastructuurAll.find(x => x.id === id);
		if (type) {
			return type.description;
		}
		return "Geen Type";
	}

	function findSporttakById(id, sporttakId) {
		const selectedSoortInfrastructuur = props.soortenInfrastructuur.find(x => x.id === id);
		if (selectedSoortInfrastructuur) {
			const sporttak = selectedSoortInfrastructuur.sporttakken.find(s => s.id === sporttakId);
			if (sporttak) {
				return sporttak.naam;
			}
		}
		return "";
	}

	const infrastructurenRows = orderByPropertyName(infrastructurenInDeBuurt, "naam").map((infrastructuur, i) => {

		const isTypeAndere = infrastructuur.soortInfrastructuurId == DomainConstants.ANDERE_INFRASTRUCTUUR_GUID
			? (<span><br />{infrastructuur.andereInfrastructuur}</span>)
			: "";

		const deelVanAanvraag = infrastructuur.deelVanAanvraag.toString() === DomainConstants.DeelVanAanvraag.Ja.toString();
		const checkboxDisabled = disabled || infrastructuur.deelVanAanvraag.toString() === DomainConstants.DeelVanAanvraag.Reconversie.toString();

		const icons = !checkboxDisabled && deelVanAanvraag ? (
			<td>
				<span style={{ fontSize: '1.2rem' }}><Popup trigger={<i className="fa fa-pencil fa-fw" onClick={onEdit(infrastructuur.id)}/>} content="Wijzig infrastructuur" /></span>
			</td>) : <td/>;

		return (
			<tr key={i}>
				<td>{infrastructuur.naam}</td>
				<td>{findById(infrastructuur.soortInfrastructuurId)}{isTypeAndere}</td>
				<td>{findSporttakById(infrastructuur.soortInfrastructuurId, infrastructuur.sporttak)}</td>
				<td style={{ verticalAlign: 'center' }}>
					<CheckBoxWithChild
						name={"gerenoveerdInProject" + i}
						value={deelVanAanvraag}
						onChange={onChange(infrastructuur.id)}
						size={1}
						disabled={checkboxDisabled}
					/>
				</td>
				{icons}
			</tr>);
	});

	return (
		<ValidationGroup validationMessages={errors ? errors : undefined} validationMessageType={validationMessageType} >
			<table className="c-table hours">
				<thead>
					<tr>
						<th width={"27%"}>NAAM VAN DE INFRASTRUCTUUR</th>
						<th width={"15%"}>TYPE</th>
						<th width={"37%"}>WELKE SPORTTAK ZAL ER HOOFDZAKELIJK BEOEFEND WORDEN? <Tooltip text={"Je hoeft deze informatie enkel aan te vullen indien de sportinfrastructuur een natuur- of kunstgrasveld betreft"} /></th>
						<th width={"21%"}>WORDT GERENOVEERD IN DIT PROJECT</th>
						<th/>
					</tr>
				</thead>
				<tbody>
					{infrastructurenRows}
				</tbody>
			</table>
		</ValidationGroup>
	);
};

// ----------------------------------------------------------------------------
RenovatieInfrastructurenTable.propTypes = {
	infrastructurenInDeBuurt: PropTypes.arrayOf(PropTypes.object),
	errors: PropTypes.object,
	validationMessageType: PropTypes.string,
	disabled: PropTypes.bool,
	onChange: PropTypes.func.isRequired,
	soortenInfrastructuur: PropTypes.array,
	soortenInfrastructuurAll: PropTypes.array,
	onDelete: PropTypes.func,
	onEdit: PropTypes.func
};

export default RenovatieInfrastructurenTable;
